module.exports = __webpack_public_path__ + "997859e37c5636aacf3335341e3a0a11.png";